import { giveawayModuleIds } from 'root/src/client/web/giveaway/descriptions/modules/moduleIds';
export const verifySteamModalModule = {
    [giveawayModuleIds.VERIFY_STEAM_MODAL_MODULE_ID]: {
        moduleType: 'modal',
    },
};
